const PLATFORM_HOSTS = new Set(['estoypidiendo.com', 'www.estoypidiendo.com', 'app.estoypidiendo.com', 'admin.estoypidiendo.com']);
const RESERVED_SUBDOMAINS = new Set(['www', 'app', 'admin']);

export function tenantSubdomainFromLocation(location: Location = window.location): string | null {
  const url = new URL(location.href);
  const explicit = url.searchParams.get('tenant')?.trim().toLowerCase();
  if (explicit) return explicit;

  const hostname = url.hostname.toLowerCase();
  if (hostname.endsWith('.localhost')) return hostname.slice(0, -'.localhost'.length);
  if (hostname === 'localhost' || hostname === '127.0.0.1' || PLATFORM_HOSTS.has(hostname)) return null;

  const parts = hostname.split('.');
  if (parts.length >= 3 && !RESERVED_SUBDOMAINS.has(parts[0])) return parts[0];
  return null;
}

export function isPlatformLandingHost(location: Location = window.location): boolean {
  return tenantSubdomainFromLocation(location) === null;
}

export function detectTenantSubdomain(): string {
  const tenant = tenantSubdomainFromLocation();
  if (tenant) return tenant;
  return import.meta.env.VITE_DEMO_TENANT || 'demo';
}

export function administrativeLoginUrl(tenantSubdomain: string): string | null {
  const hostname = window.location.hostname.toLowerCase();
  const prefix = `${tenantSubdomain.toLowerCase()}.`;
  if (!hostname.startsWith(prefix)) return null;
  const rootHostname = hostname.slice(prefix.length);
  if (!rootHostname) return null;
  const port = window.location.port ? `:${window.location.port}` : '';
  return `${window.location.protocol}//${rootHostname}${port}/login`;
}
